import { NgModule } from '@angular/core';

// Pipes
import { EllipsisPipe } from '../pipes/ellipsis.pipe';
import { SafeHtmlPipe } from '../pipes/safe-html.pipe';
import { ReplaceLibellePipe } from '../pipes/replace-libelle.pipe';

const pipes = [EllipsisPipe, SafeHtmlPipe, ReplaceLibellePipe];

@NgModule({
  declarations: [...pipes],
  imports: [],
  exports: [...pipes],
})
export class PipesModule {}
